import * as Ctx from "@/components/ui/context-menu";
import * as Dd from "@/components/ui/dropdown-menu";

/**
 * The shadcn `ContextMenu*` and `DropdownMenu*` primitives are structurally
 * identical, so the issue menu body (`IssueMenuItems`) is rendered once
 * against whichever kit the host shell supplies — right-click
 * (`ContextMenu`) or the toolbar's "Actions" button (`DropdownMenu`).
 */
export interface IssueMenuKit {
  Item: typeof Ctx.ContextMenuItem;
  Separator: typeof Ctx.ContextMenuSeparator;
  Label: typeof Ctx.ContextMenuLabel;
  Sub: typeof Ctx.ContextMenuSub;
  SubTrigger: typeof Ctx.ContextMenuSubTrigger;
  SubContent: typeof Ctx.ContextMenuSubContent;
}

export const CONTEXT_MENU_KIT: IssueMenuKit = {
  Item: Ctx.ContextMenuItem,
  Separator: Ctx.ContextMenuSeparator,
  Label: Ctx.ContextMenuLabel,
  Sub: Ctx.ContextMenuSub,
  SubTrigger: Ctx.ContextMenuSubTrigger,
  SubContent: Ctx.ContextMenuSubContent,
};

export const DROPDOWN_MENU_KIT: IssueMenuKit = {
  Item: Dd.DropdownMenuItem,
  Separator: Dd.DropdownMenuSeparator,
  Label: Dd.DropdownMenuLabel,
  Sub: Dd.DropdownMenuSub,
  SubTrigger: Dd.DropdownMenuSubTrigger,
  SubContent: Dd.DropdownMenuSubContent,
} as unknown as IssueMenuKit;
